import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { FilesService } from '@careapp-group/ng-sdk';

@Component({
  selector: 'ca-animated-category',
  styleUrls: ['./animated-category.component.scss'],
  templateUrl: 'animated-category.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EasterCategoryComponent {
  constructor(
    private filesService: FilesService,
    private cd: ChangeDetectorRef,
  ) {}

  _isSelected = false;
  _category: { id: string; name: string; animationId: string };
  public animate = false;
  public animation: AnimationOptions | undefined;

  @Output() toggleEvent = new EventEmitter<void>();

  @Input()
  set category(data: { id: string; name: string; animationId: string }) {
    if (!data) {
      return;
    }
    this._category = data;

    // I Can not explain it, but for some reason Lottie http requests are not sending
    // cookies to the API, so the usual /get URL is not working. So instead
    // we use the API to get the presigned URL for the file ID, and give that to
    // lottie instead
    this.filesService.getDownloadUrl({ id: data.animationId }).subscribe((url) => {
      this.animation = {
        path: url.url,
        loop: false,
        autoplay: false,
      };
      this.cd.detectChanges();
    });
  }

  @Input() set selected(data: boolean) {
    if (data == null) {
      return;
    }
    this._isSelected = data;
  }

  get selected() {
    return this._isSelected;
  }

  // :Note: We don't get a 'play animation' callback for lottie, but we can
  // update the animation settings, causing a refresh that doesn't loop.
  playEasterAnimation(): void {
    this.animation = {
      ...this.animation,
      autoplay: true,
      loop: false,
    };
  }

  toggle(): void {
    if (!this.selected) {
      this.playEasterAnimation();
    }
    this.animate = !this.selected;
    this.toggleEvent.emit();
  }
}
